module.exports = __webpack_public_path__ + "static/media/28DGC8.ba0d38c7.jpg";